if (!window.FCTProductSwatchGroups) {
  window.FCTProductSwatchGroups = (() => {
    const resolveContainer = (containerOrId) => {
      if (!containerOrId) return null;
      if (containerOrId instanceof Element) return containerOrId;
      if (typeof containerOrId === 'string') return document.getElementById(containerOrId);
      return null;
    };

const mount = (containerOrId) => {
		const container = resolveContainer(containerOrId);
		if (!container) return;
		const SECTION_ID = String(container.dataset.sectionId || '');
		const swatchTitle = container.dataset.swatchTitle || 'Color';
		const swatchNavigation = container.dataset.swatchNavigation || 'swap';

		const namespace = window.FCT = window.FCT || {};
		const swatchState = namespace.swatches = namespace.swatches || {};
		const bundleManager = namespace.pdpBundle || null;
		// Reuse the warmed handle Set shared by swapMainContent so repeated snippet mounts skip duplicate network work.
		const warmedHandles = window.swapMainContent?.prefetchedHandles || (swatchState.prefetchedHandles = swatchState.prefetchedHandles || new Set());

		let buttons = [];
		let activateButton = null;
		let swapToHandle = null;
		let packSwapToken = 0;
		let cacheWarmupScheduled = false; // make sure we only trigger the bulk prefetch once per render
		let sizeGuidanceEl = null;
		let swatchGuidanceEl = null;
		const guidanceDismissed = swatchState.bundleGuidanceDismissed = swatchState.bundleGuidanceDismissed || {
			size: false,
			swatches: false
		};
		if (swatchState.bundleGuidanceForcedMode !== 'size' && swatchState.bundleGuidanceForcedMode !== 'swatches') {
			swatchState.bundleGuidanceForcedMode = null;
		}

		if (container.__swatchAbortController) {
			container.__swatchAbortController.abort();
		}
		const listenersController = new AbortController();
		container.__swatchAbortController = listenersController;

		const parsePackVariantsData = () => {
			const el = document.getElementById(`ProductPackVariantsData-${SECTION_ID}`);
			if (!el) {
				swatchState.packVariants = [];
				swatchState.packVariantsBySwatchesId = null;
				return null;
			}

			try {
				const parsed = JSON.parse(el.textContent || '[]');
				swatchState.packVariants = Array.isArray(parsed) ? parsed : [];
				swatchState.packVariantsBySwatchesId = swatchState.packVariants.reduce((acc, entry) => {
					if (!entry || !entry.swatches_id) return acc;
					acc[String(entry.swatches_id)] = entry;
					return acc;
				}, {});
				return swatchState.packVariantsBySwatchesId;
			} catch (error) {
				console.warn('Pack variants data parse error', error);
				swatchState.packVariants = [];
				swatchState.packVariantsBySwatchesId = null;
				return null;
			}
		};

		const getPackVariantBySwatchesId = (swatchesId) => {
			if (!swatchesId) return null;
			const key = String(swatchesId);
			const map = swatchState.packVariantsBySwatchesId || parsePackVariantsData() || {};
			return map[key] || null;
		};

		const getShopRoot = () => {
			const root = window.Shopify?.routes?.root;
			if (typeof root === 'string' && root.trim() !== '') return root.endsWith('/') ? root : `${root}/`;
			return '/';
		};

		const applySwatchPattern = (thumb, swatchColor) => {
			if (!thumb) return;
			const raw = (swatchColor || '').toString().trim();
			if (!raw) return;

			thumb.style.background = '';
			thumb.style.backgroundImage = '';
			thumb.style.backgroundSize = '';
			thumb.style.backgroundColor = '';

			const parts = raw.split('-');
			const type = parts[0] ? parts[0].toLowerCase() : '';

			if ((type === 'striped' || type === 'stripedbig') && parts.length >= 4) {
				const colorDeg = parts[1] || '45deg';
				const firstColor = parts[2] || '';
				const secondColor = parts[3] || '';
				const stripeWidth = type === 'stripedbig' ? 6 : 3;
				const stripeRepeat = stripeWidth * 2;
				thumb.style.background = `repeating-linear-gradient(${colorDeg}, ${firstColor}, ${firstColor} ${stripeWidth}px, ${secondColor} ${stripeWidth}px, ${secondColor} ${stripeRepeat}px)`;
				thumb.style.backgroundSize = `${type === 'stripedbig' ? 10 : 5}px`;
				return;
			}

			if (type === 'gingham' && parts.length >= 3) {
				const firstColor = parts[1] || '';
				const secondColor = parts[2] || '';
				thumb.style.backgroundImage = `repeating-linear-gradient(0deg, ${firstColor}80 0 4px, transparent 4px 8px), repeating-linear-gradient(90deg, ${firstColor}80 0 4px, transparent 4px 8px)`;
				thumb.style.backgroundColor = secondColor;
				return;
			}

			thumb.style.backgroundColor = raw;
		};

		const fetchProductJson = (handle) => {
			if (!handle) return Promise.resolve(null);
			const url = `${getShopRoot()}products/${handle}.js`;
			return fetch(url, { credentials: 'same-origin' })
				.then((res) => {
					if (!res.ok) throw new Error(`Failed to load product JSON for ${handle}`);
					return res.json();
				})
				.catch((error) => {
					console.warn(error);
					return null;
				});
		};

		const ensureProductsLoaded = (handles) => {
			const uniqueHandles = Array.from(new Set((Array.isArray(handles) ? handles : []).filter((handle) => typeof handle === 'string' && handle.trim() !== '')));
			if (!uniqueHandles.length) return Promise.resolve();

			const productsByHandle = swatchState.productsByHandle = swatchState.productsByHandle || {};
			const inflight = swatchState.productFetchInflight = swatchState.productFetchInflight || {};

			const missing = uniqueHandles.filter((handle) => !productsByHandle[handle] && !inflight[handle]);
			if (!missing.length) return Promise.resolve();

			const concurrency = Math.max(1, Math.min(3, missing.length));
			let index = 0;

			const runNext = () => {
				if (index >= missing.length) return Promise.resolve();
				const handle = missing[index++];
				const promise = fetchProductJson(handle)
					.then((product) => {
						if (product && product.handle) {
							productsByHandle[product.handle] = product;
						}
					})
					.finally(() => {
						delete inflight[handle];
					});
				inflight[handle] = promise;
				return promise.then(runNext);
			};

			return Promise.all(Array.from({ length: concurrency }, runNext))
				.then(() => {
					window.swatchProductsByHandle = productsByHandle;
					swatchState.products = Object.keys(productsByHandle).map((handle) => productsByHandle[handle]);
					window.swatchProducts = swatchState.products.slice();
				});
		};
		const limitHandles = (handles, limit = 3) => {
			const uniqueHandles = Array.from(new Set((Array.isArray(handles) ? handles : []).filter((handle) => typeof handle === 'string' && handle.trim() !== '')));
			if (!uniqueHandles.length) return [];
			return uniqueHandles.slice(0, Math.max(1, limit));
		};

		const hydrateButtonThumbnails = () => {
			const body = container.querySelector('.product-swatch-groups__body');
			if (!body) return;

			const productsByHandle = swatchState.productsByHandle || {};
			const buttonsInDom = Array.from(body.querySelectorAll('.product-swatch-button'));
			if (!buttonsInDom.length) return;

			buttonsInDom.forEach((button) => {
				const groupEl = button.closest('.product-swatch-group');
				if (!groupEl || groupEl.dataset.displayMode !== 'image') return;

				const thumb = button.querySelector('.product-swatch-button__thumb');
				if (!thumb || thumb.querySelector('img')) return;

				const product = productsByHandle[button.dataset.productHandle];
				const imageData = getProductImage(product);
				if (!imageData) return;

				const img = document.createElement('img');
				img.src = imageData.src;
				if (imageData.srcset) {
					img.srcset = imageData.srcset;
					img.sizes = imageData.sizes;
				}
				img.alt = product && product.title ? product.title : button.dataset.colorDisplay || '';
				img.loading = 'lazy';
				img.decoding = 'async';
				img.fetchPriority = 'low';
				thumb.appendChild(img);
			});
		};

		const swapToHandleValue = (handle, { trigger = null, scroll = 'keep', cache = true, validate = null, force = false } = {}) => {
			if (!handle) return;
			const current = document.getElementById('main-content')?.dataset?.currentHandle || container.getAttribute('data-current-handle');
			if (!force && current && String(handle) === String(current)) return;

			const attemptSwap = (attemptsLeft = 4) => {
				if (typeof validate === 'function' && !validate()) return;
				if (typeof window.swapMainContent !== 'function') {
					if (attemptsLeft > 0) {
						requestAnimationFrame(() => attemptSwap(attemptsLeft - 1));
					}
					return;
				}
				window.swapMainContent(handle, {
					scroll,
					cache,
					trigger
				}).catch((error) => {
					if (error && error.name !== 'AbortError') console.error(error);
				});
			};

			attemptSwap();
		};

		const handlePackPickerChange = (event) => {
			if (!event || !event.detail) return;
			if (event.detail.sectionId && event.detail.sectionId !== SECTION_ID) return;

			const swatchesId = event.detail.swatches;
			if (!swatchesId) return;
			if (swatchState.activeSwatchesId && String(swatchState.activeSwatchesId) === String(swatchesId)) return;
			const trigger = event.detail.trigger || 'user';

			const packEntry = getPackVariantBySwatchesId(swatchesId);
			const nextData = packEntry && packEntry.swatch_data ? packEntry.swatch_data : null;
			if (!nextData) return;

			packSwapToken += 1;
			const token = packSwapToken;

			swatchState.activeSwatchesId = String(swatchesId);
			swatchState.rawData = nextData;
			window.fctSwatchData = nextData;

			document.dispatchEvent(new CustomEvent('fct:swatch-data-ready', {
				detail: {
					sectionId: SECTION_ID,
					handles: nextData.handles || []
				}
			}));

			// When the user changes the pack, swap the PDP to the first swatch handle for that pack.
			if (trigger === 'user') {
				const handles = Array.isArray(nextData.handles) ? nextData.handles : [];
				const targetHandle = handles.find((handle) => handle && handle.toString().trim() !== '') || null;
				if (targetHandle) {
					swapToHandleValue(targetHandle, {
						trigger: container,
						scroll: 'keep',
						cache: true,
						force: true,
						validate: () => token === packSwapToken && String(swatchState.activeSwatchesId || '') === String(swatchesId)
					});
				}
			}

			// Load missing product payloads in the background so image-mode swatches can render thumbnails.
			const warmHandles = limitHandles(nextData.handles, 3);
			ensureProductsLoaded(warmHandles)
				.then(() => {
					hydrateButtonThumbnails();
					updateButtonVisibility(readCurrentOptions());
				})
				.catch(() => {
				});
		};

		// Listen for pack picker changes and update swatches in-place.
		document.addEventListener('fct:pack-picker:change', handlePackPickerChange, { signal: listenersController.signal });

		// Collect all variant selector components for this product section.
		const getVariantSelectors = () => {
			return Array.from(document.querySelectorAll(`variant-selects[data-section="${SECTION_ID}"]`));
		};

		const getSizeFieldset = () => {
			const selectors = getVariantSelectors();
			for (const selector of selectors) {
				const directMatch = selector.querySelector('fieldset[data-handle="size"]');
				if (directMatch) return directMatch;

				const fallbackMatch = Array.from(selector.querySelectorAll('fieldset.product-form__input')).find((fieldset) => {
					const handle = String(fieldset.dataset.handle || '').trim().toLowerCase();
					if (handle === 'size') return true;
					const label = fieldset.querySelector('.form__label');
					return String(label?.textContent || '').trim().toLowerCase().startsWith('size');
				});
				if (fallbackMatch) return fallbackMatch;
			}
			return null;
		};

		const getSelectedFieldsetValue = (fieldset) => {
			if (!fieldset) return '';

			const checkedInput = fieldset.querySelector('input[type="radio"]:checked');
			if (checkedInput && String(checkedInput.value || '').trim() !== '') {
				return String(checkedInput.value || '').trim();
			}

			const selectEl = fieldset.querySelector('select');
			if (!selectEl) return '';

			const value = String(selectEl.value || '').trim();
			if (!value) return '';

			const selectedOption = selectEl.options?.[selectEl.selectedIndex] || null;
			if (selectedOption && selectedOption.disabled) return '';

			return value;
		};

		const hasSelectedSize = () => {
			return String(getSelectedFieldsetValue(getSizeFieldset()) || '').trim() !== '';
		};

		const createGuidanceElement = ({ modifier = '', title = '', body = '' } = {}) => {
			const wrapper = document.createElement('div');
			wrapper.className = `pdp-bundle-guidance${modifier ? ` ${modifier}` : ''}`;
			wrapper.hidden = true;
			wrapper.setAttribute('role', 'status');

			const titleEl = document.createElement('div');
			titleEl.className = 'pdp-bundle-guidance__title';
			titleEl.textContent = title;
			wrapper.appendChild(titleEl);

			if (body) {
				const bodyEl = document.createElement('div');
				bodyEl.className = 'pdp-bundle-guidance__body';
				bodyEl.textContent = body;
				wrapper.appendChild(bodyEl);
			}

			const dismissButton = document.createElement('button');
			dismissButton.type = 'button';
			dismissButton.className = 'pdp-bundle-guidance__dismiss';
			dismissButton.setAttribute('aria-label', 'Close tooltip');
			dismissButton.innerHTML = '&times;';
			wrapper.appendChild(dismissButton);

			return wrapper;
		};

		const ensureGuidanceNodes = () => {
			if (!bundleManager?.isActive?.()) {
				return;
			}

			const sizeFieldset = getSizeFieldset();
			if (sizeFieldset && !sizeGuidanceEl?.isConnected) {
				sizeGuidanceEl = createGuidanceElement({
					modifier: 'pdp-bundle-guidance--size',
					title: '👇 Select the size for your pack'
				});
				sizeFieldset.classList.add('pdp-bundle-guidance-anchor');
				sizeFieldset.insertBefore(sizeGuidanceEl, sizeFieldset.firstChild);
				sizeGuidanceEl.querySelector('.pdp-bundle-guidance__dismiss')?.addEventListener('click', () => {
					guidanceDismissed.size = true;
					updateBundleGuidance();
				}, { signal: listenersController.signal });
			}

			const body = container.querySelector('.product-swatch-groups__body');
			if (body && !swatchGuidanceEl?.isConnected) {
				swatchGuidanceEl = createGuidanceElement({
					modifier: 'pdp-bundle-guidance--swatches',
					title: '👇 Tap a color to add it to your pack',
					body: bundleManager?.getSwatchGuidanceBody?.() || 'Buy 5 items, save $15. Tap a color multiple times to add duplicates. Remove items from the bottom bar.'
				});
				body.classList.add('pdp-bundle-guidance-anchor');
				body.insertBefore(swatchGuidanceEl, body.firstChild);
				swatchGuidanceEl.querySelector('.pdp-bundle-guidance__dismiss')?.addEventListener('click', () => {
					guidanceDismissed.swatches = true;
					updateBundleGuidance();
				}, { signal: listenersController.signal });
			}
		};

		const updateBundleGuidance = () => {
			const isBundleModeActive = Boolean(bundleManager?.isActive?.());
			if (!isBundleModeActive) {
				swatchState.bundleGuidanceForcedMode = null;
				if (sizeGuidanceEl) sizeGuidanceEl.hidden = true;
				if (swatchGuidanceEl) swatchGuidanceEl.hidden = true;
				return;
			}

			ensureGuidanceNodes();

			const bundleCount = Array.isArray(bundleManager?.getItems?.()) ? bundleManager.getItems().length : 0;
			const sizeSelected = hasSelectedSize();
			const hasSizeFieldset = Boolean(getSizeFieldset());
			let forcedMode = swatchState.bundleGuidanceForcedMode;
			let activeGuidance = null;

			if (forcedMode === 'size' && (!hasSizeFieldset || sizeSelected)) {
				forcedMode = null;
			}

			if (forcedMode === 'size') {
				activeGuidance = 'size';
			} else if (forcedMode === 'swatches') {
				activeGuidance = 'swatches';
			} else if (hasSizeFieldset && !sizeSelected && !guidanceDismissed.size) {
				activeGuidance = 'size';
			} else if ((hasSizeFieldset ? sizeSelected : true) && bundleCount < 1 && !guidanceDismissed.swatches) {
				activeGuidance = 'swatches';
			}

			swatchState.bundleGuidanceForcedMode = forcedMode;

			if (sizeGuidanceEl) {
				sizeGuidanceEl.hidden = activeGuidance !== 'size';
			}

			if (swatchGuidanceEl) {
				swatchGuidanceEl.hidden = activeGuidance !== 'swatches';
			}
		};

		const handleGuidanceShowRequest = () => {
			const isBundleModeActive = Boolean(bundleManager?.isActive?.());
			if (!isBundleModeActive) return;

			const sizeSelected = hasSelectedSize();
			const hasSizeFieldset = Boolean(getSizeFieldset());

			if (hasSizeFieldset && !sizeSelected) {
				guidanceDismissed.size = false;
				swatchState.bundleGuidanceForcedMode = 'size';
			} else {
				guidanceDismissed.swatches = false;
				swatchState.bundleGuidanceForcedMode = 'swatches';
			}

			updateBundleGuidance();
		};

		const handleGuidanceDismiss = (event) => {
			const dismissButton = event.target.closest('.pdp-bundle-guidance__dismiss');
			if (!dismissButton) return;

			const guidanceEl = dismissButton.closest('.pdp-bundle-guidance');
			if (!guidanceEl) return;
			if (!container.contains(guidanceEl) && !getSizeFieldset()?.contains(guidanceEl)) return;

			event.preventDefault();
			event.stopPropagation();

			if (guidanceEl.classList.contains('pdp-bundle-guidance--size')) {
				guidanceDismissed.size = true;
				if (swatchState.bundleGuidanceForcedMode === 'size') {
					swatchState.bundleGuidanceForcedMode = null;
				}
			}

			if (guidanceEl.classList.contains('pdp-bundle-guidance--swatches')) {
				guidanceDismissed.swatches = true;
				if (swatchState.bundleGuidanceForcedMode === 'swatches') {
					swatchState.bundleGuidanceForcedMode = null;
				}
			}

			updateBundleGuidance();
		};

		document.addEventListener('click', handleGuidanceDismiss, { signal: listenersController.signal });
		document.addEventListener('fct:pdp-bundle-guidance:show', handleGuidanceShowRequest, { signal: listenersController.signal });

		// Read currently selected option values from the first selector instance.
		const readCurrentOptions = () => {
			const selectors = getVariantSelectors();

			if (!selectors.length) return [];

			const fieldsets = selectors[0].querySelectorAll('fieldset');
			const optionValues = [];

			fieldsets.forEach((fieldset) => {
				const selectEl = fieldset.querySelector('select');

				if (selectEl) {
					optionValues.push(selectEl.value);
					return;
				}

				const checkedInput = fieldset.querySelector('input:checked');
				optionValues.push(checkedInput ? checkedInput.value : '');
			});

			return optionValues;
		};

		const hasCompleteVariantSelection = (product, optionValues) => {
			const values = Array.isArray(optionValues) ? optionValues : [];
			const expectedCount = Array.isArray(product?.options) ? product.options.length : values.length;
			if (!expectedCount) return true;
			if (values.length < expectedCount) return false;

			for (let index = 0; index < expectedCount; index += 1) {
				const value = values[index];
				if (value === undefined || value === null || value.toString().trim() === '') {
					return false;
				}
			}

			return true;
		};

		const getBundleImageForButton = (button, product) => {
			const thumbImage = button?.querySelector('.product-swatch-button__thumb img');
			if (thumbImage?.getAttribute('src')) {
				return {
					src: thumbImage.getAttribute('src'),
					srcset: thumbImage.getAttribute('srcset') || '',
					sizes: thumbImage.getAttribute('sizes') || ''
				};
			}

			return getProductImage(product);
		};

		const createBundleItemFromTargetButton = (targetButton) => {
			if (!bundleManager || !bundleManager.isActive()) return null;
			if (!targetButton) return null;

			const targetHandle = targetButton.dataset.productHandle || '';
			if (!targetHandle) return null;

			const targetProduct = swatchState.productsByHandle?.[targetHandle] || null;
			const currentOptions = readCurrentOptions();
			if (!hasCompleteVariantSelection(targetProduct, currentOptions)) return null;

			const utils = window.FCTSwatchUtils;
			if (!utils || typeof utils.findVariantByOptions !== 'function') return null;

			const targetVariant = utils.findVariantByOptions(targetProduct, currentOptions);
			if (!targetVariant || !targetVariant.id) return null;
			const price = Number(targetVariant.price || 0);
			const discountCents = Number(bundleManager?.getDiscountCents?.() || 0);
			const bundlePrice = Math.max(0, price - discountCents);

			const title = targetProduct?.title || targetButton.getAttribute('aria-label') || '';

			return {
				handle: targetHandle,
				variantId: targetVariant.id,
				title,
				variantTitle: targetVariant.title || '',
				swatchLabel: targetButton.dataset.colorLabel || targetButton.dataset.colorDisplay || '',
				swatchValue: targetButton.dataset.colorValue || '',
				displayMode: targetButton.dataset.displayMode || 'color',
				image: getBundleImageForButton(targetButton, targetProduct),
				price,
				compareAtPrice: Number(targetVariant.compare_at_price || 0),
				bundlePrice,
				addedAt: Date.now()
			};
		};

		const resolveBundleItemForButton = (targetButton) => {
			const targetHandle = targetButton?.dataset?.productHandle || '';
			if (!targetHandle) return Promise.resolve(null);

			const existingProduct = swatchState.productsByHandle?.[targetHandle] || null;
			if (existingProduct) {
				return Promise.resolve(createBundleItemFromTargetButton(targetButton));
			}

			return ensureProductsLoaded([targetHandle]).then(() => {
				return createBundleItemFromTargetButton(targetButton);
			}).catch(() => null);
		};

		const syncBundleDecorations = () => {
			if (!bundleManager || !bundleManager.isActive() || !Array.isArray(buttons) || !buttons.length) {
				buttons.forEach((button) => {
					button.classList.remove('product-swatch-button--bundle-added', 'product-swatch-button--bundle-current', 'product-swatch-button--bundle-disabled');
					button.querySelector('.product-swatch-button__bundle-pill')?.remove();
				});
				return;
			}

			const currentHandle = container.getAttribute('data-current-handle') || '';
			const full = bundleManager.isFull();

			buttons.forEach((button) => {
				const handle = button.dataset.productHandle || '';
				const count = bundleManager.getCountByHandle(handle);
				const isCurrent = handle === currentHandle;
				const isAdded = count > 0;

				button.classList.toggle('product-swatch-button--bundle-current', isCurrent);
				button.classList.toggle('product-swatch-button--bundle-added', isAdded && !isCurrent);
				button.classList.toggle('product-swatch-button--bundle-disabled', full);

				let pill = button.querySelector('.product-swatch-button__bundle-pill');
				if (!isAdded) {
					pill?.remove();
					return;
				}

				if (!pill) {
					pill = document.createElement('span');
					pill.className = 'product-swatch-button__bundle-pill';
					pill.innerHTML = '<span class="product-swatch-button__bundle-pill-count"></span>';
					button.appendChild(pill);
				}

				const countEl = pill.querySelector('.product-swatch-button__bundle-pill-count');
				if (countEl) countEl.textContent = count;
			});
		};

		// Toggle swatch buttons based on whether a matching variant is available.
		const updateButtonVisibility = (optionValues) => {
			if (!container.isConnected) {
				listenersController.abort();
				return;
			}
			if (!Array.isArray(buttons) || !buttons.length) return;

			const utils = window.FCTSwatchUtils;
			if (!utils || typeof utils.findVariantByOptions !== 'function') return;

			const findVariantByOptions = utils.findVariantByOptions;
			const options = Array.isArray(optionValues) ? optionValues : readCurrentOptions();
			const hasConcreteSelection = Array.isArray(options) && options.some((value) => {
				return value !== undefined && value !== null && value.toString().trim() !== '';
			});
			const productsMap = window.swatchProductsByHandle || {};
			const bundleModeActive = Boolean(bundleManager?.isActive?.());
			const bundleIsFull = Boolean(bundleModeActive && bundleManager?.isFull?.());
			const currentHandle = container.getAttribute('data-current-handle') || '';
			let hasVisibleButton = false;

			buttons.forEach((button) => {
				const handle = button.dataset.productHandle;
				const product = productsMap[handle];
				let variant = null;
				let isAvailable = false;

				if (hasConcreteSelection && product) {
					variant = findVariantByOptions(product, options);
					isAvailable = !!(variant && (variant.available === undefined || variant.available === true));
				} else if (!hasConcreteSelection) {
					isAvailable = true;
				}

				const isCurrentHandle = handle === currentHandle;
				const wouldHide = !isAvailable;
				const shouldHide = wouldHide && !isCurrentHandle;
				button.classList.toggle('product-swatch-button--hidden', shouldHide);
				button.classList.toggle('product-swatch-button--bundle-disabled', bundleIsFull);
				if (shouldHide) {
					button.setAttribute('aria-hidden', 'true');
					button.tabIndex = -1;
				} else {
					button.removeAttribute('aria-hidden');
					button.removeAttribute('tabindex');
					hasVisibleButton = true;
				}

				if (bundleIsFull) {
					button.setAttribute('aria-disabled', 'true');
				} else {
					button.removeAttribute('aria-disabled');
				}
			});

			if (!hasVisibleButton && buttons.length) {
				buttons.forEach((button) => {
					button.classList.remove('product-swatch-button--hidden');
					button.removeAttribute('aria-hidden');
					button.removeAttribute('tabindex');
				});
				hasVisibleButton = true;
			}

			if (buttons.length) {
				const grouped = buttons.reduce((acc, button) => {
					const groupEl = button.closest('.product-swatch-group');

					if (!groupEl) return acc;

					const bucket = acc.get(groupEl) || [];

					bucket.push(button);
					acc.set(groupEl, bucket);

					return acc;
				}, new Map());

				grouped.forEach((groupButtons, groupEl) => {
					const anyVisible = groupButtons.some((btn) => !btn.classList.contains('product-swatch-button--hidden'));

					if (groupEl) {
						groupEl.classList.toggle('product-swatch-group--hidden', !anyVisible);
					}
				});
			}

			if (hasVisibleButton && typeof activateButton === 'function') {
				const activeVisibleButton = buttons.find((btn) => btn.classList.contains('is-active') && !btn.classList.contains('product-swatch-button--hidden'));

				if (!activeVisibleButton) {
					const fallbackButton = buttons.find((btn) => !btn.classList.contains('product-swatch-button--hidden'));
					if (fallbackButton) {
						activateButton(fallbackButton);
					}
				} else {
					updateGroupTitle(activeVisibleButton);
				}
			}

			syncBundleDecorations();
		};

		// React to variant changes triggered by the native picker component.
		const handleVariantChange = (event) => {
			if (!container.isConnected) {
				listenersController.abort();
				return;
			}
			if (!event || !event.detail) {
				return;
			}
			if (event.detail.sectionId && event.detail.sectionId !== SECTION_ID) {
				return;
			}
			const variant = event.detail.variant;
			if (variant && Array.isArray(variant.options) && variant.options.length) {
				updateButtonVisibility(variant.options);
			} else {
				updateButtonVisibility(readCurrentOptions());
			}
			updateBundleGuidance();
		};

		// Ensure the lightweight stylesheet is only added once.
		const ensureStyles = () => {
			if (document.getElementById('product-swatch-groups-styles')) return;

			const style = document.createElement('style');
			style.id = 'product-swatch-groups-styles';
			style.textContent = `
				.product-swatch-groups {					--product-swatch-image-items-gap: 0.5rem;
					--product-swatch-color-items-gap: 0.1rem;
					margin-top: 2rem;
					display: grid;
					gap: 0.75rem;
					position: relative;
				}
				.product-swatch-groups__body {
					display: grid;
					gap: 1rem;
				}
				.pdp-bundle-guidance-anchor {
					position: relative;
				}
				.pdp-bundle-guidance {
					position: absolute;
					left: 0;
					bottom: calc(100% + 10px);
					display: grid;
					gap: 0.25rem;
					width: min(100%, 320px);
					padding: 0.8125rem 0.9375rem;
					padding-right: 2rem;
					border-radius: 8px;
					background: #1e2d3b;
					color: #ffffff;
					box-shadow: 0 8px 24px rgba(0,0,0,0.18);
					animation: pdp-bundle-guidance-in 0.25s ease;
					z-index: 30;
				}
				.pdp-bundle-guidance::after {
					content: '';
					position: absolute;
					left: 20px;
					bottom: -8px;
					width: 0;
					height: 0;
					border-left: 8px solid transparent;
					border-right: 8px solid transparent;
					border-top: 8px solid #1e2d3b;
				}
				.pdp-bundle-guidance__title {
					font-size: 0.8125rem;
					line-height: 1.35;
					font-weight: 700;
				}
				.pdp-bundle-guidance__body {
					font-size: 0.6875rem;
					line-height: 1.45;
					color: rgba(255,255,255,0.78);
				}
				.pdp-bundle-guidance__dismiss {
					position: absolute;
					top: 8px;
					right: 10px;
					padding: 0;
					border: 0;
					background: transparent;
					color: rgba(255,255,255,0.6);
					font-size: 1rem;
					line-height: 1;
					cursor: pointer;
				}
				.pdp-bundle-guidance__dismiss:hover {
					color: #ffffff;
				}
				@keyframes pdp-bundle-guidance-in {
					from {
						opacity: 0;
						transform: translateY(6px);
					}
					to {
						opacity: 1;
						transform: translateY(0);
					}
				}
				.product-swatch-group {
					display: grid;
					gap: 0.5rem;
				}
				.product-swatch-group__link {
					display: inline-flex;
					align-items: center;
					width: fit-content;
					max-width: 110px;
					font-size: 0.875rem;
					font-weight: 700;
					text-decoration: underline;
					text-underline-offset: 0.15em;
					color: inherit;
					margin-left: 5px;
				}
				.product-swatch-group__title {
					font-weight: 500;
					font-size: 0.875rem;
				}
				.product-swatch-group__b2b-pricing-notice {
					font: inherit;
					font-size: 0.875rem;
					line-height: inherit;
				}
				.product-swatch-group--hidden {
					display: none;
				}
				.product-swatch-group__items {
					display: flex;
					flex-wrap: wrap;
					gap: var(--product-swatch-color-items-gap);
				}
				.product-swatch-button {
					display: inline-flex;
					align-items: center;
					justify-content: center;
					padding: 0.1875rem;
					position: relative;
					border-radius: 5px;
					border: 1px solid transparent;
					background-color: rgba(255,255,255,0.95);
					cursor: pointer;
					transition: border-color 0.2s ease, box-shadow 0.2s ease;
					color: inherit;
				}
				.product-swatch-group[data-display-mode="image"] .product-swatch-group__items {
					gap: var(--product-swatch-image-items-gap);
				}
				.product-swatch-group[data-display-mode="image"] .product-swatch-button {
					padding: 0;
				}
				.product-swatch-button:hover {
					border-color: rgba(0,0,0,0.35);
					box-shadow: 0 0 0 1px rgba(0,0,0,0.1);
				}
				.product-swatch-button.is-active {
					border-color: var(--color-accent, #000);
					box-shadow: 0 0 0 1px var(--color-accent, #000);
				}
				.pdp-bundle-mode-active .product-swatch-button.is-active,
				.pdp-bundle-mode-active .product-swatch-button.product-swatch-button--bundle-current {
					border-color: #d4af37;
					box-shadow: 0 0 0 1px #d4af37;
				}
				.pdp-bundle-mode-active .product-swatch-button.product-swatch-button--bundle-added:not(.product-swatch-button--bundle-current) {
					border-color: #000000;
					box-shadow: 0 0 0 1px #000000;
				}
        .pdp-bundle-mode-active .product-swatch-button.product-swatch-button--bundle-disabled .product-swatch-button__thumb {
          opacity: 0.7;
        }
				.product-swatch-button.is-loading {
					position: relative;
					opacity: 0.6;
					pointer-events: none;
				}
				.product-swatch-button.is-loading::after {
					content: '';
					position: absolute;
					width: 16px;
					height: 16px;
					border-radius: 50%;
					border: 2px solid rgba(0,0,0,0.2);
					border-top-color: rgba(0,0,0,0.6);
					animation: product-swatch-spinner 0.8s linear infinite;
					top: 50%;
					left: 50%;
					transform: translate(-50%, -50%);
				}
				.product-swatch-button__thumb {
					display: inline-flex;
					align-items: center;
					justify-content: center;
					height: var(--product-swatch-color-size);
					width: var(--product-swatch-color-size);
					aspect-ratio: 1 / 1;
					border-radius: 5px;
					position: relative;
					overflow: hidden;
					background-color: #dfded8;
					border: 1px solid rgba(0,0,0,0.1);
					flex-shrink: 0;
				}
				.product-swatch-group[data-display-mode="image"] .product-swatch-button__thumb {
					width: calc(var(--product-swatch-image-size) * 0.75);
					height: var(--product-swatch-image-size);
					aspect-ratio: 3 / 4;
				}
				.product-swatch-button__thumb img {
					position: static;
					display: block;
					width: 100%;
					height: 100%;
					object-fit: contain;
				}
				.product-swatch-groups--hidden {
					display: none;
				}
				.product-swatch-button__sr {
					position: absolute;
					width: 1px;
					height: 1px;
					padding: 0;
					margin: -1px;
					overflow: hidden;
					clip: rect(0, 0, 0, 0);
					border: 0;
				}
				.product-swatch-button--hidden {
					display: none !important;
				}
				.product-swatch-button__bundle-pill {
					position: absolute;
					right: -6px;
					bottom: -6px;
					display: inline-flex;
					align-items: center;
					overflow: hidden;
					border-radius: 999px;
					border: 3px solid #ffffff;
					background: #ffffff;
					font-size: 0.6875rem;
					line-height: 1;
					z-index: 2;
				}
				.product-swatch-button__bundle-pill-count {
					display: inline-flex;
					align-items: center;
					justify-content: center;
					min-width: 14px;
					height: 18px;
					padding: 0 5px;
				}
				.product-swatch-button__bundle-pill-count {
					background: #232c38;
					color: #ffffff;
					font-weight: 700;
				}
				.product-swatch-group__link.is-hidden {
					display: none !important;
				}
				@media (max-width: 769px) {
					.product-swatch-group__items {
						flex-wrap: wrap;
						overflow: visible;
						padding: 0;
						width: 100%;
					}
					.product-swatch-button__thumb {
						height: var(--product-swatch-mobile-color-size);
						width: var(--product-swatch-mobile-color-size);
					}
					.product-swatch-group[data-display-mode="image"] .product-swatch-button__thumb {
						width: calc(var(--product-swatch-mobile-image-size) * 0.75);
						height: var(--product-swatch-mobile-image-size);
					}
				}
			`;

			document.head.appendChild(style);
		};

		const getProductImage = (product) => {
			if (!product) return null;
			let src = '';

			if (product.featured_image) {
				if (typeof product.featured_image === 'string') {
					src = product.featured_image;
				} else if (product.featured_image.src) {
					src = product.featured_image.src;
				}
			}

			if (!src && Array.isArray(product.images)) {
				const firstImage = product.images.find((image) => {
					if (!image) return false;
					if (typeof image === 'string') return true;
					return !!image.src;
				});
				if (firstImage) {
					src = typeof firstImage === 'string' ? firstImage : firstImage.src;
				}
			}

			if (!src && Array.isArray(product.media)) {
				const firstMedia = product.media.find((mediaItem) => mediaItem && mediaItem.src);
				if (firstMedia) {
					src = firstMedia.src;
				}
			}

			if (!src) return null;

			if (src.startsWith('//')) {
				src = 'https:' + src;
			}

			const cleanSrc = src.split('?')[0];
			const widths = [80, 160, 240];
			const params = (w) => `?width=${w}&height=${w}`;

			return {
				src: `${cleanSrc}${params(80)}`,
				srcset: widths.map((w) => `${cleanSrc}${params(w)} ${w}w`).join(', '),
				sizes: '(min-width: 990px) 64px, 54px'
			};
		};

		const capitaliseWords = (value) => {
			return (value || '')
				.replace(/[-_]+/g, ' ')
				.split(' ')
				.filter(Boolean)
				.map((word) => word.charAt(0).toUpperCase() + word.slice(1))
				.join(' ');
		};

		const formatGroupLabel = (baseTitle, value) => {
			const rawValue = (value || '').toString().trim();
			if (!rawValue) return '';

			const isPacksGroup = (baseTitle || '').toString().trim().toLowerCase() === 'packs';
			if (!isPacksGroup) {
				return capitaliseWords(rawValue);
			}

			return rawValue
				.replace(/_+/g, ' ')
				.split('-')
				.map((chunk) => capitaliseWords(chunk))
				.filter(Boolean)
				.join('-');
		};

		const resetGroupTitles = () => {
			container.querySelectorAll('.product-swatch-group__title').forEach((titleEl) => {
		    titleEl.textContent = titleEl.dataset.baseTitle || titleEl.textContent || '';
			});
		};

		const updateGroupTitle = (button) => {
			if (!button) return;
			const groupEl = button.closest('.product-swatch-group');
			if (!groupEl) return;
			const titleEl = groupEl.querySelector('.product-swatch-group__title');
			if (!titleEl) return;
			const baseTitle = titleEl.dataset.baseTitle || titleEl.textContent || '';
			const label = formatGroupLabel(baseTitle, button.dataset.colorLabel || '');
			resetGroupTitles();
			titleEl.textContent = label ? `${baseTitle}: ${label}` : baseTitle;
		};

		const normalizeLinkButton = (linkButton) => {
			if (!linkButton || typeof linkButton !== 'object') return null;
			const label = (linkButton.label || '').toString().trim();
			const link = (linkButton.link || '').toString().trim();
			const rawActivePdpBundle = linkButton.active_pdp_bundle;
			const hasActivePdpBundleFlag = rawActivePdpBundle === true
				|| rawActivePdpBundle === 1
				|| String(rawActivePdpBundle || '').trim().toLowerCase() === 'true'
				|| String(rawActivePdpBundle || '').trim() === '1';
			const activePdpBundle = Boolean(bundleManager?.isEnabled?.()) && hasActivePdpBundleFlag;
			if (!label) return null;
			if (!activePdpBundle && !link) return null;
			return { label, link, activePdpBundle };
		};

		const createGroupLinkElement = (linkButton) => {
			if (!linkButton.activePdpBundle) {
				const linkEl = document.createElement('a');
				linkEl.className = 'product-swatch-group__link product-swatch-group__link--default';
				linkEl.href = linkButton.link;
				linkEl.textContent = `${linkButton.label} ->`;
				linkEl.setAttribute('aria-label', linkButton.label);
				return linkEl;
			}

			const fragment = document.createDocumentFragment();

			if (linkButton.link) {
				const defaultLinkEl = document.createElement('a');
				defaultLinkEl.className = 'product-swatch-group__link product-swatch-group__link--default';
				defaultLinkEl.href = linkButton.link;
				defaultLinkEl.textContent = `${linkButton.label} ->`;
				defaultLinkEl.setAttribute('aria-label', linkButton.label);
				fragment.appendChild(defaultLinkEl);
			}

			const bundleButtonEl = document.createElement('button');
			bundleButtonEl.type = 'button';
			bundleButtonEl.className = 'product-swatch-group__link product-swatch-group__link--bundle is-hidden';
			bundleButtonEl.dataset.activatePdpBundle = 'true';
			bundleButtonEl.textContent = `${linkButton.label} ->`;
			bundleButtonEl.setAttribute('aria-label', linkButton.label);
			fragment.appendChild(bundleButtonEl);

			return fragment;
		};

		// Warm the PDP cache for sibling products once the buttons exist.
		const scheduleCacheWarmup = (handles) => {
			// Disabled: prefetchMany eagerly loads sibling products and can double network usage.
			// We keep desktop hover/focus prefetch and lazy load on click instead.
			return;
		};

		// Render swatch groups and bind interactions.
		// Re-running this after data events lets us stay aligned with metafield changes or section swaps.
		const renderGroups = () => {
			if (!container.isConnected) {
				listenersController.abort();
				return;
			}
			const data = swatchState.rawData || window.fctSwatchData;
			const body = container.querySelector('.product-swatch-groups__body');
			const handles = Array.isArray(data?.handles) ? data.handles : [];
			const currentHandle = container.getAttribute('data-current-handle') || '';

			if (!body) return;
			cacheWarmupScheduled = false;
			ensureGuidanceNodes();

			if (!data || !Array.isArray(data.groups) || !data.groups.length) {
				container.classList.add('product-swatch-groups--hidden');
				updateBundleGuidance();
				return;
			}

			const renderKey = `${swatchState.activeSwatchesId || ''}|${handles.join(',')}|${bundleManager?.isActive?.() ? 'bundle' : 'default'}`;
			if (container.dataset.renderKey === renderKey) {
				return;
			}
			container.dataset.renderKey = renderKey;

			// Full re-render keeps markup aligned with metafield updates.
			body.innerHTML = '';

			container.classList.remove('product-swatch-groups--hidden');

			const productsByHandle = swatchState.productsByHandle = swatchState.productsByHandle || {};
			window.swatchProductsByHandle = productsByHandle;

			const globalLinkButton = normalizeLinkButton(data.link_button);
			const showB2BSeasonalPricingNotice = container.dataset.isB2bCustomer === 'true'
				&& container.dataset.showB2bSeasonalPricingNotice === 'true';

			data.groups.forEach((group, groupIndex) => {
				if (!group || !Array.isArray(group.items) || !group.items.length) {
					return;
				}

				const displayMode = (group.display_mode || 'color').toString().trim().toLowerCase();

				const groupEl = document.createElement('div');
				groupEl.className = 'product-swatch-group';
				groupEl.dataset.displayMode = displayMode;

				// Section heading within the swatch group.
				const titleEl = document.createElement('div');
				titleEl.className = 'product-swatch-group__title';
				titleEl.textContent = group.name || swatchTitle;
				titleEl.dataset.baseTitle = titleEl.textContent;
				groupEl.appendChild(titleEl);

				if (showB2BSeasonalPricingNotice && /seasonal/i.test(group.name || '')) {
					const pricingNoticeEl = document.createElement('div');
					pricingNoticeEl.className = 'product-swatch-group__b2b-pricing-notice';
					pricingNoticeEl.textContent = 'Not available for volume-based pricing discount';
					groupEl.appendChild(pricingNoticeEl);
				}

				const itemsEl = document.createElement('div');
				itemsEl.className = 'product-swatch-group__items';

				group.items.forEach((item) => {
					if (!item || !item.handle) return;
					if (displayMode === 'color' && (!item.value || item.value.toString().trim() === '')) return;

					const product = productsByHandle[item.handle];
					if (!product) {
						// Fallback to global cache when not preloaded in the map.
						const fallbackProduct = Array.isArray(window.swatchProducts)
							? window.swatchProducts.find((p) => p && p.handle === item.handle)
							: null;
						if (fallbackProduct) {
							productsByHandle[item.handle] = fallbackProduct;
						}
					}

					const resolvedProduct = productsByHandle[item.handle];
					if (!resolvedProduct) {
						console.debug('Missing swatch product for handle', item.handle);
					}
					const button = document.createElement('button');
					button.type = 'button';
					button.className = 'product-swatch-button';
					button.dataset.groupName = group.name || '';
					button.dataset.productHandle = item.handle;
					button.dataset.colorLabel = item.label || '';
					button.dataset.colorValue = item.value || '';
					button.dataset.displayMode = displayMode;
					button.dataset.swapMainContent = 'true';
					button.dataset.swapScroll = 'keep';

					if (item.handle === currentHandle) {
						button.classList.add('is-active');
						button.setAttribute('aria-pressed', 'true');
					} else {
						button.setAttribute('aria-pressed', 'false');
					}

					const thumb = document.createElement('span');
					thumb.className = 'product-swatch-button__thumb';

					if (displayMode === 'color') {
						// When display_mode is "color", render a solid color chip instead of a product image.
						const swatchColor = (item.value || item.label || '').toString().trim();
						applySwatchPattern(thumb, swatchColor);
					} else {
						const imageData = getProductImage(resolvedProduct);
						if (imageData) {
							const img = document.createElement('img');
							img.src = imageData.src;
							if (imageData.srcset) {
								img.srcset = imageData.srcset;
								img.sizes = imageData.sizes;
							}
							img.alt = (resolvedProduct && resolvedProduct.title) ? resolvedProduct.title : item.label || '';
							img.loading = 'lazy';
							img.decoding = 'async';
							img.fetchPriority = 'low';
							thumb.appendChild(img);
						}
					}

					const capitalizedLabel = capitaliseWords(item.label || item.handle || '');
					button.dataset.colorDisplay = capitalizedLabel;
					button.title = capitalizedLabel;
					button.setAttribute('aria-label', capitalizedLabel);

					button.appendChild(thumb);
					const srText = document.createElement('span');
					srText.className = 'product-swatch-button__sr';
					srText.textContent = capitalizedLabel;
					button.appendChild(srText);
					itemsEl.appendChild(button);
				});

				groupEl.appendChild(itemsEl);

				const groupLinkButton = normalizeLinkButton(group.link_button);
				const isLastGroup = groupIndex === data.groups.length - 1;
				const linkToRender = groupLinkButton || (isLastGroup ? globalLinkButton : null);
				if (linkToRender) {
					if (!(bundleManager?.isActive?.() && linkToRender.activePdpBundle)) {
						itemsEl.appendChild(createGroupLinkElement(linkToRender));
					}
				}

				body.appendChild(groupEl);
			});

			resetGroupTitles();

			buttons = Array.from(body.querySelectorAll('.product-swatch-button'));

			const clearLoading = function (handle) {
				buttons.forEach(function (button) {
					if (handle && button.dataset.productHandle !== handle) return;
					button.classList.remove('is-loading');
					button.removeAttribute('aria-busy');
				});
			};

			if (!cacheWarmupScheduled && buttons.length) {
				const handlesForWarmup = buttons
					.map((btn) => btn.dataset.productHandle)
					.filter((handle) => typeof handle === 'string' && handle.trim() !== '');
				scheduleCacheWarmup(handlesForWarmup);
			}

			activateButton = (targetButton, commitHandle = true) => {
				if (!targetButton) return;

				buttons.forEach((btn) => {
					const isActive = btn === targetButton;
					btn.classList.toggle('is-active', isActive);
					btn.setAttribute('aria-pressed', isActive ? 'true' : 'false');

					if (isActive) {
						btn.classList.remove('is-loading');
						btn.removeAttribute('aria-busy');
					}
				});

				if (commitHandle) {
					container.setAttribute('data-current-handle', targetButton.dataset.productHandle || '');
				}

				updateGroupTitle(targetButton);
			};

			const pendingState = {
				handle: null,
				button: null,
				previous: null
			};

			const setButtonPending = (button, isPending) => {
				if (!button) return;
				button.classList.toggle('is-loading', !!isPending);
				if (isPending) {
					button.setAttribute('aria-busy', 'true');
					button.disabled = true;
				} else {
					button.removeAttribute('aria-busy');
					button.disabled = false;
				}
			};

			swapToHandle = (button) => {
				if (!button) return;
				const handle = button.dataset.productHandle;
				if (!handle) return;
				if (swatchNavigation === 'featured-section') {
					if (typeof window.FCTFeaturedProductSwap?.swap !== 'function') {
						return Promise.reject(new Error('Featured Product swap is unavailable'));
					}
					return window.FCTFeaturedProductSwap.swap(container, handle, { trigger: button });
				}
				if (swatchNavigation === 'product-url') {
					const root = getShopRoot();
					window.location.assign(`${root}products/${encodeURIComponent(handle)}`);
					return;
				}
				const currentHandle = container.getAttribute('data-current-handle');
				if (currentHandle === handle) return;
				if (button.dataset.swapBusy === 'true') return;
				if (!window.swapMainContent || typeof window.swapMainContent !== 'function') return;

				pendingState.previous = buttons.find((btn) => btn.classList.contains('is-active')) || null;
				pendingState.handle = handle;
				pendingState.button = button;

				activateButton(button, false);
				setButtonPending(button, true);

				button.dataset.swapBusy = 'true';
				const scroll = button.dataset.swapScroll || 'keep';
				const cache = button.dataset.swapCache !== 'false';

				window.swapMainContent(handle, {
					scroll,
					cache,
					trigger: button
				}).catch((error) => {
					if (error && error.name !== 'AbortError') console.error(error);
				}).finally(() => {
					delete button.dataset.swapBusy;
				});
			};

			buttons.forEach((button) => {
				button.addEventListener('click', (event) => {
					const handle = button.dataset.productHandle;
					if (!handle) return;
					const currentHandle = container.getAttribute('data-current-handle');
					if (swatchNavigation === 'featured-section' && currentHandle !== handle) {
						event.preventDefault();
						event.stopPropagation();
						setButtonPending(button, true);
						Promise.resolve(swapToHandle(button)).catch((error) => {
							console.error(error);
							setButtonPending(button, false);
						});
						return;
					}
					if (swatchNavigation === 'product-url' && !bundleManager?.isActive?.() && currentHandle !== handle) {
						event.preventDefault();
						window.location.assign(`${getShopRoot()}products/${encodeURIComponent(handle)}`);
						return;
					}
					if (button.dataset.bundleAddBusy === 'true') {
						event.preventDefault();
						event.stopPropagation();
						return;
					}

					if (bundleManager?.isActive?.()) {
						if (bundleManager.isFull()) {
							event.preventDefault();
							event.stopPropagation();
							return;
						}

						swatchState.bundleGuidanceForcedMode = null;
						guidanceDismissed.swatches = true;
						updateBundleGuidance();

						event.preventDefault();
						event.stopPropagation();
						button.dataset.bundleAddBusy = 'true';
						setButtonPending(button, true);

						resolveBundleItemForButton(button).then((bundleItem) => {
							if (!bundleItem) {
								setButtonPending(button, false);
								return;
							}

							const addResult = bundleManager.addItem(bundleItem, {
								source: 'swatch-click',
								sectionId: SECTION_ID
							});

							if (!addResult.ok) {
								setButtonPending(button, false);
								return;
							}

							if (currentHandle === handle) {
								setButtonPending(button, false);
								updateButtonVisibility(readCurrentOptions());
								return;
							}

							// Load the clicked swatch product on demand; cache prevents repeat fetches.
							ensureProductsLoaded([handle]).then(() => {
								hydrateButtonThumbnails();
							}).catch(() => {});
							if (typeof swapToHandle === 'function' && typeof window.swapMainContent === 'function') {
								swapToHandle(button);
								return;
							}
							if (currentHandle === handle) return;

							pendingState.previous = buttons.find((btn) => btn.classList.contains('is-active')) || null;
							pendingState.handle = handle;
							pendingState.button = button;

							activateButton(button, false);
							setButtonPending(button, true);
						}).catch(() => {
							setButtonPending(button, false);
						}).finally(() => {
							delete button.dataset.bundleAddBusy;
						});

						return;
					}

					// Load the clicked swatch product on demand; cache prevents repeat fetches.
					ensureProductsLoaded([handle]).then(() => {
						hydrateButtonThumbnails();
					}).catch(() => {});
					if (typeof swapToHandle === 'function' && typeof window.swapMainContent === 'function') {
						swapToHandle(button);
						event.preventDefault();
						event.stopPropagation();
						return;
					}
					if (currentHandle === handle) return;

					pendingState.previous = buttons.find((btn) => btn.classList.contains('is-active')) || null;
					pendingState.handle = handle;
					pendingState.button = button;

					activateButton(button, false);
					setButtonPending(button, true);
					event.preventDefault();
				});

				if (swatchNavigation === 'swap' && window.swapMainContent && typeof window.swapMainContent.prefetch === 'function') {
					const prefetch = () => {
						if (!window.matchMedia('(min-width: 768px)').matches) return;
						window.swapMainContent.prefetch(button.dataset.productHandle);
					};
					button.addEventListener('pointerenter', prefetch, { once: true });
					button.addEventListener('focus', prefetch, { once: true });
				}
			});

			Array.from(body.querySelectorAll('[data-activate-pdp-bundle="true"]')).forEach((linkButton) => {
				linkButton.addEventListener('click', (event) => {
					event.preventDefault();
					if (!bundleManager?.activate?.({ source: 'link_button', sectionId: SECTION_ID })) return;
					renderGroups();
				});
			});

			if (typeof AbortController === 'function') {
				const addSwapListener = function (name, handler) {
					document.addEventListener(name, function (event) {
						if (!container.isConnected) {
							listenersController.abort();
							return;
						}
						handler(event);
					}, {signal: listenersController.signal});
				};

				addSwapListener('pdp:swap:start', function (event) {
					if (!event.detail || event.detail.handle !== pendingState.handle) return;
					if (event.detail.trigger && event.detail.trigger !== pendingState.button) return;
					setButtonPending(pendingState.button, true);
				});

				addSwapListener('pdp:swap:success', function (event) {
					if (!event.detail || event.detail.handle !== pendingState.handle) return;
					setButtonPending(pendingState.button, false);
					clearLoading(event.detail.handle);
					container.setAttribute('data-current-handle', pendingState.handle || '');
					pendingState.handle = null;
					pendingState.button = null;
					pendingState.previous = null;
				});

				addSwapListener('pdp:swap:error', function (event) {
					if (!event.detail || event.detail.handle !== pendingState.handle) return;
					setButtonPending(pendingState.button, false);
					clearLoading();
					if (pendingState.previous) {
						activateButton(pendingState.previous, true);
					}
					pendingState.handle = null;
					pendingState.button = null;
					pendingState.previous = null;
				});

				if (container.parentNode) {
					const observer = new MutationObserver(function () {
						if (!container.isConnected) {
							listenersController.abort();
							observer.disconnect();
						}
					});
					observer.observe(container.parentNode, {childList: true});
				}
			} else {
				document.addEventListener('pdp:swap:success', function () {
					clearLoading();
				});
				document.addEventListener('pdp:swap:error', function () {
					clearLoading();
				});
			}

			const initialActiveButton = buttons.find((btn) => btn.dataset.productHandle === currentHandle) || buttons[0];
			if (initialActiveButton) {
				activateButton(initialActiveButton);
			}

			// Align visibility state with the initial selection.
			updateButtonVisibility(readCurrentOptions());
			updateBundleGuidance();

			// Lazily hydrate missing product payloads (e.g. when switching packs) so image swatches can render thumbnails.
			// No initial bulk hydration: products are fetched lazily on click, with desktop-only hover prefetch.
		};

		const handleDataReady = (event) => {
			if (!container.isConnected) {
				listenersController.abort();
				return;
			}
			if (!event || !event.detail) return;
			if (event.detail.sectionId && event.detail.sectionId !== SECTION_ID) return;

			renderGroups();
		};

		ensureStyles();

		if (document.readyState === 'loading') {
			// Delay rendering until DOM is interactive when snippet loads early.
			document.addEventListener('DOMContentLoaded', renderGroups, { once: true, signal: listenersController.signal });
		} else {
			renderGroups();
		}

		document.addEventListener('fct:swatch-data-ready', handleDataReady, { signal: listenersController.signal });
		document.addEventListener('product:variant-change', handleVariantChange, { signal: listenersController.signal });
		document.addEventListener('fct:pdp-bundle:update', () => {
			updateButtonVisibility(readCurrentOptions());
			updateBundleGuidance();
		}, { signal: listenersController.signal });
		document.addEventListener('fct:pdp-bundle:mode-change', () => {
			renderGroups();
		}, { signal: listenersController.signal });
		document.addEventListener('change', (event) => {
			const target = event.target;
			if (!target) return;
			if (target.closest(`variant-selects[data-section="${SECTION_ID}"]`)) {
				updateBundleGuidance();
			}
		}, { signal: listenersController.signal });
		document.addEventListener('fct:swatch-utils-ready', () => {
			updateButtonVisibility(readCurrentOptions());
		}, { once: true, signal: listenersController.signal });
	};

    const mountAll = () => {
      document.querySelectorAll('[data-product-swatch-groups-root]').forEach((container) => {
        mount(container);
      });
    };

    return {
      mount,
      mountAll
    };
  })();
}

